import React, { Component } from 'react';
import HTML5Backend from 'react-dnd-html5-backend';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-dnd';
import './App.css';

import EditorWrapper from './components/editor-wrapper/EditorWrapper';
import PagePreviewContainer from './components/page-preview-container/PagePreviewContainer';
import {
  hideComponent,
  browserNotSupported } from './redux/helpers';

class App extends Component {
  constructor(args) {
    super(...args);
    this.state = {
      hideComponent: false,
    };
  }

  componentWillMount() {
    if (hideComponent()) {
      this.setState({
        hideComponent: true,
      });
    }
  }


  render() {
    const { lang } = this.props;

    if (browserNotSupported()) {
      return (
        <div className="unsopported">
          <p>{lang.browserNotSupported}</p>
        </div>
      );
    }

    return (
      <div className="BookDesigner">
        <div className="Topbar" />
        <div className="BookDesigner_ContentColumn">
          <div className="BookDesignerTopBar">
            <PagePreviewContainer lang={lang} />
          </div>

          <div className="BookDesigner_MiddleWrapper">
            <div className={`BookDesigner_LeftColumn ${this.state.hideComponent ? 'hide' : ''} `} />
            <div className={`BookDesigner_MiddleColumn ${this.state.hideComponent ? 'hide' : ''}`}>
              <EditorWrapper lang={lang} />
              <div className="BookDesigner_BottomBar" />
            </div>
          </div>
        </div>
        <div className="BookDesigner_RightColumn" />
      </div>
    );
  }
}

App.defaultProps = {
  lang: {},
};

App.propTypes = {
  lang: PropTypes.object,
};

export default DragDropContext(HTML5Backend)(App);



// WEBPACK FOOTER //
// ./src/App.jsx